import {Media} from "../utils/consts";

/**
 * Функционал для воспроизведения видео в карточках продуктов при наведении курсора
 *
 */
class PlayVideo {
  #videoElements;

  constructor({autoInit = true}) {
    this.onVideoMouseOver = this.onVideoMouseOver.bind(this);
    this.onVideoMouseLeave = this.onVideoMouseLeave.bind(this);

    if (autoInit) {
      this.#videoElements = document.querySelectorAll(".js-item-video");

      if (this.#videoElements.length > 0) {
        this.#videoElements.forEach((element) => this.addListeners(element));
      }
    }
  }

  #activateVideo(video) {
    video.play();
    video.classList.add("product-card__video--visible");
  }

  #deactivateVideo(video) {
    video.pause();
    video.classList.remove("product-card__video--visible");
  }

  #observerCallback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        activateVideo(entry.target);
      } else {
        this.#deactivateVideo(entry.target);
      }
    });
  }

  onVideoMouseOver({currentTarget}) {
    this.#activateVideo(currentTarget);
  }

  onVideoMouseLeave({currentTarget}) {
    this.#deactivateVideo(currentTarget);
  }

  addListeners(videoElement) {
    if (!Media.TABLET) {
      videoElement.addEventListener("mouseover", this.onVideoMouseOver);
      videoElement.addEventListener("mouseleave", this.onVideoMouseLeave);
    } else {
      const observer = new IntersectionObserver(this.#observerCallback, {threshold: 0.5});

      observer.observe(videoElement);
    }
  }
}

export {PlayVideo};
